import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b71b5f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default page-media" }
const _hoisted_2 = { class: "page-path path-links" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_5 = { class: "page-title c-primary" }
const _hoisted_6 = { class: "tags" }
const _hoisted_7 = { class: "filters" }
const _hoisted_8 = {
  key: 0,
  class: "not-found c-secondary"
}

import i18, { State as I18State } from '@/store/i18';
import movieCategories, { State } from '@/store/movies/categories';
import { ViewContext } from '@/views';
import Pagination from '@/views/components/Pagination.vue';
import * as links from '@/views/links';
import { computed, inject, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Album from '../albums/Album.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const context = inject('context') as ViewContext;
const store = useStore()
const router = useRouter()
const data = computed<State>(() => store.state[movieCategories.name])
const list = computed(() => data.value.albums.slice(0, data.value.pageSize))

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])

const container = ref<HTMLDivElement>()

onMounted(() => {
    window.onresize = onResize;
    onResize();
})

onBeforeUnmount(() => {
    window.onresize = null
})

function onResize() {
    let rect = container.value?.getBoundingClientRect() as DOMRect;
    if (rect.width > 0) {
        let size = Math.floor((rect.width + 20) / 170);
        data.value.pageSize = Math.ceil(20 / size) * size;
    } else {
        data.value.pageSize = 24
    }
}

function go(query: any) {
    if (query.order) {
        router.push(`/content/category/id/${query.cid}/page/${query.page}/order/` + query.order)
    } else {
        router.push(`/content/category/id/${query.cid}/page/${query.page}/index.html`)
    }
}


function onPageChange(page: number) {
    const query = Object.assign({ cid: data.value.cid, order: data.value.order }, { page })
    go(query);
}

function onOrderChange(order: string) {
    const query = Object.assign({ page: data.value.page, cid: data.value.cid }, { order })
    go(query);
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "link",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(lang).topMenu.movie), 1)
        ]),
        _: 1
      }),
      (_unref(data).parent.length == 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _createElementVNode("span", null, _toDisplayString(_unref(lang).movieMenu.category), 1)
          ], 64))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).parent, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          _hoisted_4,
          _createVNode(_component_router_link, {
            class: "link line",
            to: _unref(links).category(item.id)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ], 64))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("b", null, _toDisplayString(_unref(data).currentCategory?.name), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).categories, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: "btn round gray",
          to: _unref(links).category(item.id)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("a", {
        class: _normalizeClass(["link", { on: _unref(data).order == '' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onOrderChange('')))
      }, _toDisplayString(_unref(lang).movieText.filter_sort_default), 3),
      _createElementVNode("a", {
        class: _normalizeClass(["link", { on: _unref(data).order == 'time' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onOrderChange('time')))
      }, _toDisplayString(_unref(lang).movieText.filter_sort_update), 3),
      _createElementVNode("a", {
        class: _normalizeClass(["link", { on: _unref(data).order == 'hot' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (onOrderChange('hot')))
      }, _toDisplayString(_unref(lang).movieText.filter_sort_hot), 3)
    ]),
    _createElementVNode("div", {
      class: "albums",
      ref_key: "container",
      ref: container,
      style: {"min-height":"400px"}
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
        return (_openBlock(), _createBlock(Album, { album: item }, null, 8, ["album"]))
      }), 256)),
      (_unref(data).albums.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(lang).movieText.empty), 1))
        : _createCommentVNode("", true)
    ], 512),
    _createVNode(Pagination, {
      total: _unref(data).total,
      page: _unref(data).page,
      size: _unref(data).pageSize,
      onChange: onPageChange
    }, null, 8, ["total", "page", "size"])
  ]))
}
}

})